<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <h2>
            시험 생성
          </h2>
          <p class="gray">시험을 생성합니다.</p>
        </div>
      </div>
      <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="140px" class="demo-form">
        <div class="card-body gray">
          <div class="card-form textarea">
            <el-form-item label="시험명" prop="title">
              <el-input v-model="frm.title" placeholder="시험명을 입력하십시오." maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="시험지" prop="exam_paper_title">
              <el-input placeholder="시험지를 선택하십시오." v-model="frm.exam_paper_title" class="input-with-select" disabled>
                <el-button slot="prepend" icon="el-icon-search" @click="openPaper"></el-button>
                <el-button slot="append" icon="el-icon-delete" @click="deletePaperTag"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="유형">
              {{examPaperInfo.exam_paper_type_name}}
            </el-form-item>
            <el-form-item label="카테고리">
              {{examPaperInfo.cate_path}}
            </el-form-item>
            <el-form-item label="교재">
              {{examPaperInfo.book_name}}
            </el-form-item>
            <el-form-item label="회차">
              {{examPaperInfo.times}}
            </el-form-item>
            <el-form-item label="커리큘럼">
              {{examPaperInfo.curriculum_name}}
            </el-form-item>
            <!-- <el-form-item label="시험기간">
              <el-date-picker
                v-model="examTerm"
                type="daterange"
                range-separator="~"
                value-format="yyyyMMdd"
                start-placeholder="시험 시작일"
                end-placeholder="시험 종료일">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="설명" prop="content">
              <el-input type="textarea" :rows="3" v-model="frm.content" placeholder="시험 설명을 입력하십시오."></el-input>
            </el-form-item>
            <el-form-item label="알림톡 전송">
              <el-switch v-model="isSendMsg" active-text="" inactive-text=""></el-switch>
            </el-form-item>
            <el-form-item label="시험지 공개">
              <el-switch v-model="isOepnPaper" active-text="" inactive-text=""></el-switch>
            </el-form-item>
            <el-form-item label="온라인 시험">
              <el-switch v-model="isUseOnline" active-text="" inactive-text=""></el-switch>
            </el-form-item>
            <el-form-item label="대상 클래스" prop="exam_class" v-if="isUseOnline">
              <el-select v-model="frm.exam_online_class" multiple placeholder="선택하세요." style="width: 100%;">
                <el-option v-for="item in onlineClassData" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="시험 종료 미사용">
              <el-switch v-model="isUseExamClose" active-text="" inactive-text="" :disabled="isUseOnline"></el-switch>
            </el-form-item>
          </div>
        </div>
        <div class="card-body text-right">
          <el-button type="default" @click="resetForm('frm')">취소</el-button>
          <el-button type="primary" @click="submitForm('frm')">저장</el-button>
        </div>
      </el-form>
    </div>
    <el-dialog title="시험지 조회" :visible.sync="dialogTableVisible" append-to-body width="70%">
      <h5>
        시험지 <strong><span class="number mint">{{tableData.length}}</span></strong>
      </h5>
      <el-input v-model="examPaperFilters[0].value" placeholder="시험지명" prefix-icon="el-icon-search" class="user-filter"></el-input>
      <stone-data-table
        :loading="searchLoading"
        :columns="tableColumns"
        :data="tableData"
        :filters="examPaperFilters"
        :table-props="tableProps"
        :action-col="actionCol">
      </stone-data-table>
      <div class="card-body text-right">
        <!-- <el-button type="primary">선택</el-button> -->
        <el-button @click="dialogTableVisible = false">닫기</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M050102',
  mixins: [common.mixins],
  data () {
    return {
      isOepnPaper: false,
      isSendMsg: true,
      isUseOnline: false,
      isUseExamClose: false,
      isModify: true,
      examTerm: [],
      dialogTableVisible: false,
      examPaperInfo: {},
      frm: {
        exam_seq: 0,
        title: '',
        exam_type: '',
        content: '',
        exam_paper_seq: 0,
        exam_paper_title: '',
        open_dt: '',
        close_dt: '',
        stat: 'N',
        use_yn: 'Y',
        paper_open_yn: 'N',
        send_msg_yn: 'Y',
        online_yn: 'N',
        exam_online_class: [],
        close_yn: 'N'
      },
      rules: {
        title: [
          { required: true, message: '시험명을 입력하십시오.', trigger: 'blur' },
          { min: 3, max: 30, message: '최소 3자 이상 최대 50자까지 입력하십시오.' }
        ],
        exam_paper_title: [
          { required: true, message: '시험지를 선택하십시오.' }
        ],
        content: [
          { required: false, message: '시험에 대한 설명을 입력하십시오.', trigger: 'blur' }
        ]
      },
      tableData: [],
      tableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false},
        // {label: '시험지번호', prop: 'exam_paper_seq', align: 'left', width: 80},
        {label: '유형', prop: 'exam_paper_type_name', align: 'center', width: 80},
        {label: '시험지명', prop: 'title', align: 'left', width: 200},
        {label: '카테고리', prop: 'cate_path', align: 'left', width: 100},
        {label: '커리큘럼', prop: 'book_name', align: 'left', width: 100},
        {label: '회차', prop: 'times', align: 'center', width: 80},
        {label: '문제수', prop: 'quiz_cnt', align: 'right', width: 80}
      ],
      examPaperFilters: [
        {prop: ['title'], value: ''}
      ],
      currentPage: 0,
      tableProps: {height: 400},
      actionCol: {
        label: '선택',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.examPaperInfo = row
            this.frm.exam_paper_title = row.title
            this.$nextTick(() => {
              this.dialogTableVisible = false
            })
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '선택'
        }]
      },
      onlineClassData: []
    }
  },
  beforeCreate () {
  },
  created () {
    common.axios.post('/class/list', {online_yn: 'Y'})
      .then(response => {
        const result = response.data
        result.forEach(c => {
          this.onlineClassData.push({label: c.class_name, value: c.class_seq, disabled: c.use_yn === 'N'})
        })
        this.$nextTick(() => {
          const examSeq = this.$route.params.exam_seq
          if (examSeq && examSeq !== 0) {
            this.loadInfo(examSeq)
          }
        })
      })
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEmpty(this.examPaperInfo.exam_paper_seq)) {
            this.$message.error('시험지 내용을 확인하십시오.')
            return
          }

          if (this.isUseOnline && this.frm.exam_online_class.length === 0) {
            this.$message.error('온라인 시험 대상 클래스를 지정하십시오.')
            return
          }
          this.frm.exam_paper_seq = this.examPaperInfo.exam_paper_seq
          this.frm.exam_type = this.examPaperInfo.exam_paper_type

          if (this.examTerm !== null && this.examTerm.length > 0) {
            this.frm.open_dt = this.examTerm[0]
            this.frm.close_dt = this.examTerm[1]
          }

          const isInsert = this.frm.exam_seq === 0
          const config = {
            url: isInsert ? '/exam/storage' : '/exam',
            method: isInsert ? 'post' : 'put',
            data: this.frm
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.status === 1) {
                if (isInsert) {
                  this.$message('등록하였습니다.')
                } else {
                  this.$message('수정하였습니다.')
                }
                setTimeout(() => {
                  this.$router.push({name: 'M050101', params: {isSearch: true}})
                }, 1000)
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.clearForm()
      setTimeout(() => {
        this.$router.push({name: 'M050101', params: {isSearch: true}})
      }, 1000)
    },
    clearForm () {
      this.frm.exam_seq = 0
      this.isOepnPaper = false
      this.examTerm = []
      this.deletePaperTag()
    },
    loadInfo (examSeq) {
      common.axios.get('/exam/load/' + examSeq)
        .then(response => {
          const result = response.data
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })
          this.isOepnPaper = result.exam.paper_open_yn === 'Y'
        })
    },
    handleChange (value) {
      console.log('value : ', value)
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options4 = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options4 = []
      }
    },
    loadPaper () {
      this.loadStoneDataTable('/paper/list/', {exception_paper_type: 'note'})
        .then(response => {
          this.tableData = response.data
        })
    },
    openPaper () {
      this.dialogTableVisible = true
      this.loadPaper()
    },
    deletePaperTag () {
      this.examPaperInfo = {}
      this.frm.exam_paper_title = ''
    }
  },
  watch: {
    isOepnPaper: function (value) {
      this.frm.paper_open_yn = value ? 'Y' : 'N'
    },
    isSendMsg: function (value) {
      this.frm.send_msg_yn = value ? 'Y' : 'N'
    },
    isUseOnline: function (value) {
      this.frm.online_yn = value ? 'Y' : 'N'
      // 온라인 시험인 경우에는 시험 종료 미사용 사용 금지
      if (value) {
        this.isUseExamClose = false
        this.frm.close_yn = 'N'
      }
    },
    isUseExamClose: function (value) {
      this.frm.close_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .user-filter {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M050102.vue